<template>
  <div class="small-footer acr-bold" :class="{'nb': noBorder, 'hide': hide}">
    <div class="small-footer-rights"> ML version: {{mlVersion}}, Release: {{version}},  {{new Date(buildVersion).toLocaleDateString("en-US",{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}}</div>
    <!--<div class="small-footer-rights"> Release: {{new Date(buildVersion).toLocaleDateString("en-US",{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })}}</div>-->
    <!--<div class="small-footer-rights"> Acronis #CyberSport © All rights reserved</div>-->
    <div class="small-footer-links">
      <a class="small-footer-link">
        <!--Contact us-->
      </a>
      <a class="small-footer-link">
        <!--Privacy policy-->
      </a>
      <a class="small-footer-link">
        <!--Terms of use-->
      </a>
    </div>
  </div>
</template>

<script>
  import { fetchRestVersion } from "../../api/services";

  export default {
      name: "SmallFooter",
      props: ['noBorder', 'hide'],
      data() {
        return {
          version: '',
          mlVersion: ''
        }
      },
      computed: {
        buildVersion() {
          return document.documentElement.dataset.buildTimestampUtc
        }
      },
      created() {
        fetchRestVersion().then((res) => {
          this.version = res.data.api_version;
          this.mlVersion = res.data.ml_version;
        })
      },
    }
</script>

<style lang="scss">
  .small-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 18px;
    color: rgba(36, 49, 67, 0.6);
    border-top: 1px solid rgba(36, 49, 67, 0.1);
    background-color: #fff;
    margin-top: 3px;
    border-radius: 3px;
    &.nb {
      border: none;
    }
    &.hide {
      opacity: 0;
    }
    &-links {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    &-link {
      margin-left: 22px;
      transition: all .3s ease-in-out;
      &:hover {
        color: #8AAF1A;
      }
    }
  }
</style>
